import {
    AppBar,
    Container,
    Grid,
    IconButton,
    Tab,
    Tabs,
    Toolbar,
} from "@mui/material";
import { ReactNode, forwardRef } from "react";

// import Email from '@mui/icons-material/Email'
import CloudDownload from "@mui/icons-material/CloudDownload";

import { ArrowBack } from "@mui/icons-material";

// eslint-disable-next-line react/display-name
const NavLink = forwardRef<
    HTMLSpanElement,
    {
        href: string;
        children: ReactNode;
    }
>((props, ref) => (
    <span ref={ref} {...props}>
        <a className="ReportNavLink" href={props.href}>
            {props.children}
        </a>
    </span>
));

const Navbar = ({
    tabValue,
    tabHandler,
    tabs = [],
    downloadUrl,
    onBack,
}: {
    tabValue: number;
    tabHandler: (tab: number) => void;
    tabs: { label: string; href: string }[];
    downloadUrl: string;
    onBack?: VoidFunction;
}) => {
    const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        tabHandler(newValue);
    };
    return (
        <AppBar position="fixed">
            <Toolbar
                sx={{
                    backgroundColor: "white",
                    display: "block",
                    maxWidth: "100vw",
                    paddingX: 0,
                    paddingLeft: 0,
                }}
                style={{
                    paddingLeft: 0,
                    paddingRight: 0,
                }}
            >
                <Container>
                    <Grid container justifyContent="space-between" alignItems="center">
                        <Grid item>
                            {onBack && (
                                <IconButton onClick={onBack} size="large">
                                    <ArrowBack />
                                </IconButton>
                            )}
                        </Grid>
                        <Grid item>
                            <IconButton
                                component="a"
                                href={downloadUrl}
                                download
                                target="_blank"
                                size="large"
                            >
                                <CloudDownload />
                            </IconButton>
                        </Grid>
                    </Grid>
                </Container>
                <Tabs
                    onChange={handleChange}
                    value={tabValue}
                    indicatorColor="primary"
                    textColor="primary"
                    sx={(theme) => ({
                        backgroundColor: theme.palette.secondary.main,
                        padding: 0,
                        m: 0,
                        [theme.breakpoints.up("sm")]: {
                            "& .MuiTabs-scroller .MuiTabs-flexContainer": {
                                justifyContent: "center",
                            },
                        },
                    })}
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    {tabs.map(({ label, href }) => (
                        <Tab
                            key={label}
                            component={NavLink}
                            label={label}
                            href={"#" + href}
                        />
                    ))}
                </Tabs>
            </Toolbar>
        </AppBar>
    );
};
export default Navbar;
